module.exports = __webpack_public_path__ + "img/hcdl_thumbnail.06765f7a.jpg";